<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-alert class="mb-0" v-if="error" tile type="error">{{
                    error
                }}</v-alert>
                <v-card-title class="primary white--text">{{
                    formTitle
                }}</v-card-title>
                <v-card-text class="pt-5">
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="editedItem.name"
                                    :rules="[rules.required]"
                                    type="text"
                                    label="Name*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="editedItem.printPriority"
                                    type="number"
                                    label="Print Priority"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="close">Cancel</v-btn>
                    <v-btn
                        outlined
                        rounded
                        :loading="isSaving"
                        color="primary"
                        @click="save"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import helper from "@/utils/helper.js";

export default {
    name: "product_category-edit-dialog",
    props: ["dialog", "object"],
    data() {
        return {
            error: null,
            isSaving: false,
            editedItem: {
                id: "",
                name: "",
                printPriority: null
            },
            defaultItem: {
                id: "",
                name: "",
                printPriority: null
            },
            rules: {
                required: (v) => !helper.isEmpty(v) || "This field is required",
                minLength: (len) => (v) =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: (len) => (v) => (v || "").length <= len || "Too long"
            }
        };
    },
    computed: {
        formTitle() {
            return this.object
                ? "Edit Product Category"
                : "New Product Category";
        }
    },
    watch: {
        // reset form when dialog open or close
        dialog() {
            this.resetForm();
        }
    },
    methods: {
        resetForm() {
            // reset form state
            this.error = null;
            this.isSaving = false;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // when editing, set form with object
            if (this.dialog && this.object) {
                this.editedItem.id = this.object.id;
                this.editedItem.name = this.object.name;
                this.editedItem.printPriority = this.object.printPriority;
            }
            // when new or closing, set form with default
            else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
        },

        close() {
            this.$emit("update:dialog", false);
            this.resetForm();
        },

        save() {
            // check if form valid
            if (!this.$refs.form.validate()) {
                return;
            }

            // set form state
            this.error = null;
            this.isSaving = true;

            // prepare api call payload
            var payload = {
                name: this.editedItem.name
            };

            if (this.editedItem.printPriority) {
                payload = {
                    ...payload,
                    printPriority: this.editedItem.printPriority
                };
            }

            // edit
            if (this.object) {
                // prepare graphql mutation payload
                payload.id = this.editedItem.id;

                // if editing
                this.$store
                    .dispatch(
                        "productCategories/updateProductCategory",
                        payload
                    )
                    .then((response) => {
                        // update parent object
                        this.$emit("update:object", response);
                        this.close();
                    })
                    .catch((error) => {
                        this.error = error.graphQLErrors[0].message;
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
            // new
            else {
                this.$store
                    .dispatch(
                        "productCategories/createProductCategory",
                        payload
                    )
                    .then((response) => {
                        this.$emit("item-created", response);
                        this.close();
                    })
                    .catch((error) => {
                        this.error = error.graphQLErrors
                            .map((error) => error.message)
                            .join(", ");
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>